export const environment = {
  production: true,
  apiWithUrl: 'https://nonstop-nine-koala.glitch.me'
};
